import { Button, Grid, makeStyles, Theme, Typography } from '@material-ui/core';
import { colors, InstructionsLayout } from 'design-system';
import { useState } from 'react';
import { HelpCircle } from 'react-feather';

const useStyles = makeStyles((theme: Theme) => ({
  linkStyle: {
    '&:hover, &:focus': {
      backgroundColor: `${colors.white}`,
    },
    padding: 0,
    minWidth: 0,
  },
  modalText: {
    fontWeight: 400,
    fontSize: 15,
    lineHeight: '22px',
    textAlign: 'justify',
    margin: 60,
    marginTop: 20,
    [theme.breakpoints.down('xs')]: {
      margin: 20,
    },
  },
}));

const BrokerPercentageHelp = (): JSX.Element => {
  const classes = useStyles();
  const [isOpen, toggleIsOpen] = useState<boolean>(false);

  return (
    <Grid item data-testid="brokerPercentageId">
      <Button
        className={classes.linkStyle}
        id="sales-web-button-insuredvaluehelp"
        data-testid="button-insured-value-help"
        onClick={(): void => toggleIsOpen(!isOpen)}
      >
        <HelpCircle color={colors.bright_turquoise} />
      </Button>
      <InstructionsLayout
        open={isOpen}
        headerTitle="Porcentaje de Participación"
        onCloseRequested={() => toggleIsOpen(false)}
        id="sales-web-modal-broker-porcentage-help"
        data-testid="modal-percentage-broker"
        title={
          <img
            src="../svg/img-porcentaje-participa.svg"
            alt="porcentage-participacion"
          />
        }
        instructions=""
        content={
          <Grid container>
            <Grid item>
              <Typography className={classes.modalText}>
                La <strong>participación</strong> es el{' '}
                <strong>porcentaje de la comisión</strong> que será asignado a
                tu licencia. Si agregas más licencias a la póliza, el porcentaje
                será compartido con el resto de las licencias.
              </Typography>
            </Grid>
          </Grid>
        }
      />
    </Grid>
  );
};

export default BrokerPercentageHelp;
